import OrganizationForm from './OrganizationForm';

export default OrganizationForm;
